import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["provider-locations"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      providerLocationsRequestPlanRetrieve: build.query<
        ProviderLocationsRequestPlanRetrieveApiResponse,
        ProviderLocationsRequestPlanRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/request-plan/`,
          params: {
            include_inactive: queryArg.includeInactive,
          },
        }),
        providesTags: ["provider-locations"],
      }),
      providerLocationsRequestPlanCreate: build.mutation<
        ProviderLocationsRequestPlanCreateApiResponse,
        ProviderLocationsRequestPlanCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/request-plan/`,
          method: "POST",
          body: queryArg.providerRequestPlanUpsertRequest,
        }),
        invalidatesTags: ["provider-locations"],
      }),
      providerLocationsRequestPlanUpdate: build.mutation<
        ProviderLocationsRequestPlanUpdateApiResponse,
        ProviderLocationsRequestPlanUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/request-plan/${queryArg.planId}/`,
          method: "PUT",
          body: queryArg.providerRequestPlanUpsertRequest,
        }),
        invalidatesTags: ["provider-locations"],
      }),
      providerLocationsRequestPlanActivate: build.mutation<
        ProviderLocationsRequestPlanActivateApiResponse,
        ProviderLocationsRequestPlanActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/request-plan/${queryArg.planId}/activate/`,
          method: "POST",
        }),
        invalidatesTags: ["provider-locations"],
      }),
      providerLocationsRequestPlanDeactivate: build.mutation<
        ProviderLocationsRequestPlanDeactivateApiResponse,
        ProviderLocationsRequestPlanDeactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/request-plan/${queryArg.planId}/deactivate/`,
          method: "POST",
        }),
        invalidatesTags: ["provider-locations"],
      }),
      providerLocationsRoutingOptions: build.query<
        ProviderLocationsRoutingOptionsApiResponse,
        ProviderLocationsRoutingOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-locations/${queryArg.providerLocationId}/routing-options/`,
        }),
        providesTags: ["provider-locations"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type ProviderLocationsRequestPlanRetrieveApiResponse =
  /** status 200  */ ProviderRequestPlanSchema;
export type ProviderLocationsRequestPlanRetrieveApiArg = {
  /** When true, return an inactive plan if no active plan exists. */
  includeInactive?: boolean;
  providerLocationId: string;
};
export type ProviderLocationsRequestPlanCreateApiResponse =
  /** status 201  */ ProviderRequestPlanSchema;
export type ProviderLocationsRequestPlanCreateApiArg = {
  providerLocationId: string;
  providerRequestPlanUpsertRequest: ProviderRequestPlanUpsertRequest;
};
export type ProviderLocationsRequestPlanUpdateApiResponse =
  /** status 200  */ ProviderRequestPlanSchema;
export type ProviderLocationsRequestPlanUpdateApiArg = {
  planId: string;
  providerLocationId: string;
  providerRequestPlanUpsertRequest: ProviderRequestPlanUpsertRequest;
};
export type ProviderLocationsRequestPlanActivateApiResponse =
  /** status 200  */ ProviderRequestPlanSchema;
export type ProviderLocationsRequestPlanActivateApiArg = {
  planId: string;
  providerLocationId: string;
};
export type ProviderLocationsRequestPlanDeactivateApiResponse =
  /** status 200  */ ProviderRequestPlanSchema;
export type ProviderLocationsRequestPlanDeactivateApiArg = {
  planId: string;
  providerLocationId: string;
};
export type ProviderLocationsRoutingOptionsApiResponse =
  /** status 200  */ ProviderRequestPlanRoutingOptionsResponse;
export type ProviderLocationsRoutingOptionsApiArg = {
  providerLocationId: string;
};
export type TreatmentRecordTypes =
  | "Bills"
  | "Records"
  | "Facility Records"
  | "Facility Bills"
  | "Radiology"
  | "ER Physician Bills"
  | "Other"
  | "Unknown";
export type ProviderRequestPlanRoutingLocation = {
  type?: "location";
  location_id?: (string | string) | null;
};
export type ProviderRequestPlanRoutingService = {
  type?: "service";
  service_id: string | string;
};
export type ProviderRequestPlanScopeSchema = {
  scope: TreatmentRecordTypes;
  routing:
    | ({
        type: "location";
      } & ProviderRequestPlanRoutingLocation)
    | ({
        type: "service";
      } & ProviderRequestPlanRoutingService);
  sort_order?: number;
};
export type ProviderRequestPlanSchema = {
  id: string | string;
  provider_location_id: string | string;
  is_active: boolean;
  scopes?: ProviderRequestPlanScopeSchema[];
  created_at?: string | null;
  modified_at?: string | null;
};
export type ProviderRequestPlanUpsertRequest = {
  scopes?: ProviderRequestPlanScopeSchema[];
};
export type ProviderRequestPlanRoutingOptionLocation = {
  type?: "location";
  id?: (string | string) | null;
  name: string;
  is_anchor?: boolean;
};
export type ProviderRequestPlanRoutingOptionService = {
  type?: "service";
  id: string | string;
  name: string;
  service_type?: string | null;
};
export type ProviderRequestPlanRoutingOptionsResponse = {
  anchor_location_id: string | string;
  anchor_location_name: string;
  locations?: ProviderRequestPlanRoutingOptionLocation[];
  services?: ProviderRequestPlanRoutingOptionService[];
};
export const {
  useProviderLocationsRequestPlanRetrieveQuery,
  useProviderLocationsRequestPlanCreateMutation,
  useProviderLocationsRequestPlanUpdateMutation,
  useProviderLocationsRequestPlanActivateMutation,
  useProviderLocationsRequestPlanDeactivateMutation,
  useProviderLocationsRoutingOptionsQuery,
} = injectedRtkApi;
